import {useDragLayer} from 'react-dnd';

import TabDragPreview from "./TabDragPreview";
import PartitionDragPreview from "./PartitionDragPreview";
import SubpartitionDragPreview from "./SubpartitionDragPreview";
import IconDragPreview from './IconDragPreview';
import dndItems from './dndItems';

import "./dnd.css";


function getItemStyles(initialOffset, currentOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        };
    }
    let { x, y } = currentOffset;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebkitTransform: transform,
    };
}

export const CustomDragLayer = (props) => {
    const {itemType, isDragging, item, initialOffset, currentOffset} = useDragLayer(monitor => ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging(),
    }));

    function renderItem() {
        switch (itemType) {
            case dndItems.icon:
                return <IconDragPreview iconIds={item.iconIds} icons={props.icons}/>;
            case dndItems.subpartition:
                return <SubpartitionDragPreview item={item} tabs={props.tabs}/>
            case dndItems.partition:
                return <PartitionDragPreview item={item} tabs={props.tabs}/>
            case dndItems.tab:
                return <TabDragPreview item={item} tabs={props.tabs}/>
            default:
                return null;
        }
    }


    return (isDragging ? <div className="custom-drag-layer-container">
        <div style={getItemStyles(initialOffset, currentOffset)}>
            {renderItem()}
        </div>
    </div> : null);
};
